// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-01c9030e] .faq ul{padding-bottom:1em}[data-v-01c9030e] .faq ol{padding-top:1em}[data-v-01c9030e] .faq h2{padding-bottom:1em}[data-v-01c9030e] .faq :before{left:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
